import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, LunchpageService } from '../_services';
import { Globals } from '../_helpers';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'feedback-start',
    templateUrl: './feedback-start.component.html',
})

export class FeedbackstartComponent {
    spocnameFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(3),
    ]);
    languageFormControl = new FormControl('', [
        Validators.required,
        //Validators.pattern('valid'),       
    ]);
    mobileFormControl = new FormControl('', [
        Validators.required,
        //Validators.minLength(10),
        Validators.pattern("[0-9]{10}"),
    ]);
    addressFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(3),
    ]);   
    traindateFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(9),
    ]);
    trainernameFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(3),
    ]);
    TOTLocFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(3),      
    ]);
    traineridFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(3),      
    ]);    
    trainernoFormControl = new FormControl('', [
        Validators.required,
        //Validators.minLength(10),
        Validators.pattern("[0-9]{10}"),
    ]); 
    TOTDurFormControl = new FormControl('', [
        Validators.required,
        //Validators.minLength(10),
        Validators.pattern("[0-9]{2}"),
    ]);       
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    userData = {};
    feedback_id: number;   
    feedback_assessor_id: number;   
    feedbackdone: number;           
    aadhar: number;          
    total_student: number;          
    sector_name: string;           
    batch_name: string;           
    student_assessment_lang : string;          
    center_add_sdms : string;          
    alternate_id : string;          
    center_id : string;          
    tc_name: string;
    assessor_name: string;
    tp_name: string;
    agency_name: string;
    subject_name: string;
    localData = {};
    minDate: Date;
    maxDate: Date;
    languages = []; 

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private LunchpageService: LunchpageService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {
        const d = new Date();
        const currentYear = new Date().getFullYear();
        this.minDate = new Date(currentYear - 5, 0, 1);
        this.maxDate = new Date(currentYear, d.getMonth(), d.getDate());
    }


    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        //if (step != this.globals.complSteps['feedback-start'])
            //this.router.navigateByUrl('/login');
            //this.userData = JSON.parse(localStorage.getItem('currentUser'));
            //console.log(this.userData);
            // get return url from route parameters or default to '/'
            //this.returnUrl = '/';
/*            console.log(step);
            return;*/
        this.localData = JSON.parse(localStorage.getItem('currentUser'));    
        this.getFeedback();
        this.getlanguage();
    }


    public getFeedback() {
        this.LunchpageService.getFeedbackInfo(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'])
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) { 
                    let feedback =  data.detail;
                    this.feedback_id = data.feedback_id;             
                    this.feedback_assessor_id = data.feedback_assessor_id;             
                    this.feedbackdone = data.feedbackdone;             
                    this.aadhar = feedback.aadhar;             
                    this.alternate_id = feedback.alternate_id;             
                    this.batch_name = feedback.batch_name;             
                    this.center_add_sdms = feedback.center_add_sdms;             
                    this.center_id = feedback.center_id;             
                    this.sector_name = feedback.sector_name;             
                    this.student_assessment_lang = feedback.student_assessment_lang;             
                    this.assessor_name = feedback.assessor_name; 
                    this.tc_name = feedback.tc_name; 
                    this.total_student = feedback.total_student; 
                    this.tp_name = feedback.tp_name; 
                    this.agency_name = feedback.agency_name; 
                    this.subject_name = feedback.subject_name; 
                    let sett = { 'feedbackid': this.feedback_id, 'feedback_status': this.feedbackdone };
                    sessionStorage.setItem('pkshn_feedback_set_a', JSON.stringify(sett)); 
                    if(this.feedbackdone == 1)
                    {
                        this.router.navigateByUrl('/batch-detail'); 
                    }                                 
              }
              else if (data.code == 1001) {
                this.loading = false;
                this.isErrorLogin = false;
                //this.router.navigateByUrl('/login');
              }
            }
          )
    }
    public getlanguage() {
        this.LunchpageService.getlanguage(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'])
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) { 
                    var lang =  data.languages;
                    for (var i = 0; i < data.languages.length; ++i) {
                        this.languages[i] = { id: lang[i].id, lang_name: lang[i].lang_name};
                    }                                 
              }
              else if (data.code == 1001) {
                this.loading = false;
                this.isErrorLogin = false;
                //this.router.navigateByUrl('/login');
              }
            }
          )
    }    
    public onSubmit() {
        this.submitted = true;
        if (this.spocnameFormControl.valid == false || this.languageFormControl.valid == false || this.mobileFormControl.valid == false || this.addressFormControl.valid == false || this.traindateFormControl.valid == false || this.trainernameFormControl.valid == false || this.TOTLocFormControl.valid == false || this.traineridFormControl.valid == false || this.trainernoFormControl.valid == false || this.TOTDurFormControl.valid == false) {
            this.isErrorLogin = false;
            return false;
        }
        else {
            this.loading = true;
            this.spinner.show();
            this.LunchpageService.setFeedbackInfo(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'], this.feedback_id, this.spocnameFormControl.value, this.mobileFormControl.value, this.languageFormControl.value, this.addressFormControl.value, this.traindateFormControl.value, this.trainernameFormControl.value, this.TOTLocFormControl.value, this.traineridFormControl.value, this.trainernoFormControl.value, this.TOTDurFormControl.value)
              .pipe(first())

              .subscribe(
                data => {
                  if (data.code == 1000) {
                        this.loading = false;
                        this.spinner.hide();
                        var params = this.feedback_assessor_id + '@@' + this.feedback_id
                        this.router.navigateByUrl('/feedback/' + params);
                  }
                  else if (data.code == 1001) {
                    this.loading = false;
                    this.isErrorLogin = false;
                    //this.router.navigateByUrl('/login');
                  }
                }
              )            
        }
    } 
    public gotoDashboard(){
        this.router.navigateByUrl('/home/'+this.localData['exam_id']+'/'+this.localData['viva_assessor']+'/'+this.localData['viva_pc']); 
    }       
}
